function cov_2reljc0l18() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateAddFilled.tsx";
  var hash = "2581ff855f7328ce8cc21426dc1e5d6e2babe4fe";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateAddFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2581ff855f7328ce8cc21426dc1e5d6e2babe4fe"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2reljc0l18 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2reljc0l18();
var Icon = (cov_2reljc0l18().s[0]++, {
  name: 'date-add-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 3C8.25 2.30964 7.69036 1.75 7 1.75C6.30964 1.75 5.75 2.30964 5.75 3V4H5C3.34315 4 2 5.34315 2 7V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V7C22 5.34315 20.6569 4 19 4H18.25V3C18.25 2.30964 17.6904 1.75 17 1.75C16.3096 1.75 15.75 2.30964 15.75 3V4H8.25V3ZM5 9C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11H19C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9H5ZM13.25 13.5C13.25 12.8096 12.6904 12.25 12 12.25C11.3096 12.25 10.75 12.8096 10.75 13.5V14.25H10C9.30964 14.25 8.75 14.8096 8.75 15.5C8.75 16.1904 9.30964 16.75 10 16.75H10.75V17.5C10.75 18.1904 11.3096 18.75 12 18.75C12.6904 18.75 13.25 18.1904 13.25 17.5V16.75H14C14.6904 16.75 15.25 16.1904 15.25 15.5C15.25 14.8096 14.6904 14.25 14 14.25H13.25V13.5Z\" fill=\"currentColor\"/>"
});
export default Icon;